import { siteIDs } from '../../../adapters/utils';
import { SCHEMA_TYPES } from './schema-types';
var schema = {
    '@context': 'https://schema.org/',
    '@type': 'WebSite',
    name: "{{".concat(siteIDs.SITE_NAME, "}}"),
    url: "{{".concat(siteIDs.SITE_URL, "}}"),
};
var requiredSchemaVariables = [siteIDs.SITE_NAME, siteIDs.SITE_URL];
export default {
    type: SCHEMA_TYPES.HOME_PAGE,
    schema: schema,
    requiredSchemaVariables: requiredSchemaVariables,
};
